/** Fixed deployment URL: no caller-supplied redirect host or access token in navigation. */
export function operationsUrl(configured, path = '/connect') {
  const url = new URL(configured)
  const local = ['localhost', '127.0.0.1'].includes(url.hostname)
  if (url.username || url.password || !(url.protocol === 'https:' || (local && url.protocol === 'http:'))) {
    throw new Error('运营平台地址配置无效')
  }
  url.pathname = path
  url.search = ''
  url.hash = ''
  return url
}

export function validateOperationsCallback(configured, redirectUrl, state) {
  const expected = operationsUrl(configured, '/callback')
  const actual = new URL(redirectUrl)
  if (
    actual.origin !== expected.origin ||
    actual.pathname !== expected.pathname ||
    actual.hash ||
    actual.username ||
    actual.password ||
    actual.searchParams.get('state') !== state ||
    !/^[A-Za-z0-9_-]{43}$/.test(actual.searchParams.get('code') || '')
  ) {
    throw new Error('运营平台登录回调无效')
  }
  return actual.href
}
